import config from '../config';
import {
  getJobCardsTemplate,
  getJobCardsTemplateFailed,
  addCustomField,
} from '../actions/jobCardsTemplate';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';

export function getAllFields() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/jobCardTemplate/getAllFieldsWithOptions`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getJobCardsTemplate({list: json}));
          }
        })
        .catch(response => dispatch(getJobCardsTemplateFailed({error: response})));
    }
  }
};

export function removeItemById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/jobCardTemplate/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(notify({
              title: 'Delete custom field',
              message: 'Custom field deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

export function updateOrder(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/jobCardTemplate/orderFields`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getAllFields());
            dispatch(notify({
              title: 'Update order',
              message: 'Order updated successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Update Order',
            message: 'Failed to update order',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function setJobCardsTemplate(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/jobCardTemplate/updateFields`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          dispatch(addCustomField(data));
          if (json) {
            dispatch(notify({
              title: 'Update fields',
              message: 'Fields updated successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Update fields',
            message: 'Failed to update fields',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/jobCardsTemplate.js